import React from 'react';

/**
 * Footer component
 */
function Footer() {
    return (
        <div className="ev-footer">
            Powered by <span>Energic</span>
        </div>
    );
}

export default Footer;
